export type Voucher = {
    Id: number;
    VoucherId: string;
    VoucherTypeId: number;
    RoundsLeft: number;
    RoundsTotal: number;
    WinAmount: number;
    Committed: boolean;
    Ended: boolean;
    DefaultStake: number;
    RoundsUsed: number;
    TokenRenew: string;
};
